import { Boundaries, Size } from "@hokuto/jam-core";
import { TILE_SIZE } from "../const.js";

export function useArea(
  args: Partial<Size> & { margin?: Partial<Boundaries>; area?: number }
) {
  const {
    width = TILE_SIZE,
    height = TILE_SIZE,
    margin: originMargin = {},
    area: originArea = 0,
  } = args;

  const { top = 0, left = 0, right = 0, bottom = 0 } = originMargin;
  const margin = { top, right, bottom, left };
  const viewBoxWidth = width + left + right;
  const viewBoxHeight = height + top + bottom;
  const area = originArea || viewBoxWidth * viewBoxHeight;

  return {
    width,
    height,
    margin,
    area,
    viewBoxWidth,
    viewBoxHeight,
  };
}
